"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var addons_1 = require("@storybook/addons");
var react_1 = __importDefault(require("react"));
var config_1 = require("./config");
var DecoratorWrapper_1 = __importDefault(require("./DecoratorWrapper"));
exports.default = addons_1.makeDecorator({
    name: 'withColorPicker',
    parameterName: config_1.PARAMETER_ID,
    wrapper: function (storyFn, context) {
        var params = addons_1.useParameter(config_1.PARAMETER_ID, {
            defaultTheme: core_1.createMuiTheme()
        });
        return (react_1.default.createElement(DecoratorWrapper_1.default, { defaultTheme: params.defaultTheme }, storyFn(context)));
    }
});
